<template>
    <span>
        <div v-if="material===null" class="material-line-title row no-wrap">
            <div class='data-block col-6 textCenter'>Наименование</div>
            <div class="data-block col-1 textCenter">Ширина, м</div>
            <div class="data-block col-1 textCenter">Цена за кв.м.</div>
            <div class="data-block col-1 textCenter">В наличии, п.м.</div>
            <div class="col-3"></div>
        </div>
        <div v-if="material!==null" class="material-line row no-wrap" >
            <div class='data-block col-6'>
                <div v-if="!editMode" class="topOffset">{{material.name}}</div>
                <span v-if="editMode">
                    <q-input v-model="editName" autofocus inverted size='sm' :loading="isLoading" @keydown="checkEnter" />
                </span>
            </div>
            <div class="data-block col-1 textCenter">
                <div v-if="!editMode" class="topOffset">{{material.width}}</div>
                <span v-if="editMode">
                    <div style='width:100%'>
                        <q-input v-model="editWidth"  size='xs' inverted type="number" :loading="isLoading" @keydown="checkEnter"/>
                    </div>
                </span>
            </div>
            <div class="data-block col-1 textCenter topOffset">{{material.price}}</div>
            <div class="data-block col-1 textCenter topOffset">{{material.count}}</div>
            <div class="col-3" style="text-align:right; padding:4px;">
                <!-- Standard mode -->
                <div v-if='!editMode' class="topOffset">
                    <q-btn icon='delete_outline' color='negative' size='sm' @click="deleteMaterial"  outline />
                    <q-btn icon='edit' color='positive' size='sm' @click='editMaterial' class='q-ml-sm'/>
                    <q-btn icon='swap_vert' color='primary' size='sm'  class='q-ml-sm q-mr-sm' @click='correctDialog'/>
                </div>
                <!-- Edit mode -->
                <div v-if='editMode' class="topOffset">
                    <q-btn icon='cancel' color='negative' size='sm' outline @click='cancelEditMaterial' class='q-mr-sm'/>
                    <q-btn icon='save' color='positive' size='sm' @click='saveMaterial' :loading='isLoading' class='q-mr-sm' />
                </div>
            </div>
        </div>
    </span>
</template>

<script>
/* eslint-disable */
export default {
    name : 'materialLineNomenklatura',
    props : {
        material : {
            type : Object,
            requered : true,
        },
        newLine : {
            type: Boolean,
            required : true,
        }
    },
    data () {
        return {
            editMode : false,
            editName : '',
            editWidth : '',
            isLoading : false,
        }
    },
    created() {
        if (this.newLine) {
            this.editMode = true;
            this.editName = this.material.name;
            this.editWidth = this.material.width;
            console.log(this.material.type_id);
        } 
        else {
            if (this.material != null) {
                this.editName = this.material.name;
                this.editWidth = this.material.width;
            }
        }
        
    },
    methods : {
        correctDialog() {
            eventBus.$emit("showCorrectDialog", this.material.id);
        },

        checkEnter(event) {
            if (event.key=='Enter') { //если был нажат enter - то сохраняем и выходим из режима редактирования
                this.saveMaterial();
            }
            if (event.key=='Escape') { //отмена редактирования
                this.cancelEditMaterial();
            }
        },

        saveMaterial() {
            var isOk = true;
            if (this.editName=='') {
                isOk = false;
                this.$admns.showNotify('Необходимо задать наименование материала','error','Сообщение системы');
            }
            if (this.editWidth=='') {
                isOk = false;
                this.$admns.showNotify('Необходимо задать ширину материала','error','Сообщение системы');
            }
            if (isOk) { //если прошло проверку то сохраняем в базу

                this.isLoading = true;

                var data = {
                    id : this.material.id,
                    name : this.editName,
                    width : this.editWidth,
                    type_id : this.material.type_id,
                }

                this.$store.dispatch('saveNomenklatura', data)
                .then( ()=>{
                    this.editMode = false;
                    this.isLoading = false;
                    if (this.material.id == -1) { // это значит добавляем новую запись
                        eventBus.$emit("hideNewLine");
                    }
                })
                .catch(()=>{
                    this.isLoading = false;
                });

            }
        },

        cancelEditMaterial() {
            this.editMode = false;
            if (this.material.id == -1) eventBus.$emit("hideNewLine"); // значит мы отменяем в процессе добавления новой записи
            this.$admns.showNotify('Отмена редактирования материала','error','Сообщение системы');
        },

        deleteMaterial() {
            this.$q.dialog({
                title: 'Внимание!',
                message: 'Подтвердите удаление записи "'+ this.material.name+'"',
                color: 'primary',
                ok: "Да, удалить",
                cancel: 'Нет', 
            })
            .then(()=>{ //юзер подтвердил - удаляем

                this.$store.dispatch('deleteNomenklatura', this.material)
                .then(()=>{
                    this.$admns.showNotify('Запись успешно удалена','success','Сообщение системы');
                })
                .catch((error) => {
                    console.log(error);
                    this.$admns.showNotify('Ошибка при удалении записи','error','Сообщение системы');
                });

            })   
            .catch(()=>{});
        },
        editMaterial() {
            this.editName = this.material.name;
            this.editWidth = this.material.width;
            this.editMode = true;
        },
    },

}
</script>

<style lang="scss" scoped>
    .material-line {
        width:100%;
        min-height: 62px;
        text-align:left;
        font-family: Arial, Helvetica, sans-serif;
        font-size:14px;
        font-weight: bold;
        background: rgb(238, 238, 238);
        border : 1px solid gray;

        &:hover {
            background : rgb(202, 255, 202);
        }
    }
    .data-block {
        border-right : 1px solid white;
        padding : 10px;
     }    
    .textCenter {
        text-align : center;
    }
    .material-line-title {
        width:100%;
        text-align:left;
        font-family: Arial, Helvetica, sans-serif;
        font-size:14px;
        background: rgb(44, 65, 124);
        border : 1px solid gray;
        margin-bottom: -1px;
        color : white;
    }
    .topOffset {
        margin-top:13px;
    }
</style>


